// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2Hbe7","NavItems":"SideDrawer_NavItems__3C4Db","Open":"SideDrawer_Open__3DkYN","Close":"SideDrawer_Close__2Jjy1"};